import ajaxHandler from '../util/ajaxLoadMore';

export default {
  init() {
  },
  finalize() {
    ajaxHandler('.btn-load-more-posts', '.posts-listing', global.binah_data_gated_assets);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/gated-assets.js